export default __webpack_public_path__ + "static/media/s663-3.169a7b0d.png";